import { render, staticRenderFns } from "./teacher-edit.vue?vue&type=template&id=c0b5cbd4"
import script from "./teacher-edit.vue?vue&type=script&lang=js"
export * from "./teacher-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports